
const translations = {
  nav_about: "Chi siamo",
  nav_services: "Servizi",
  nav_method: "Metodo",
  nav_library: "Biblioteca",
  nav_contact: "Contatto",
  nav_login: "Accedi",
  nav_register: "Registrati",
  nav_my_profile: "Il mio profilo",
  nav_availability: "Stato disponibilità",
  nav_processes: "I miei processi",
  nav_edit: "Modifica informazioni",
  nav_privacy: "Informativa sulla privacy",
  nav_logout: "Esci",
  nav_company_account: "Account aziendale",
  nav_professional_account: "Account professionale",
  hero_badge: "International Placement",
  hero_title_1: "Selezione strategica di talenti in Europa",
  hero_title_2: "International Placement",
  hero_subtitle: "Società strategica di selezione e collocamento internazionale in Europa.",
  hero_markets: "Germania · Svizzera · Paesi Bassi · Austria · Belgio",
  hero_cta_talent: "Cerca talenti",
  hero_cta_explore: "Esplora opportunità",
  hero_social_proof: "+120 professionisti collocati in Europa",
};

export default translations;
